import React, { Component } from 'react';
import FormClient from '../sales/FormClient';
import FormSale from '../sales/FormSale';

import { isEmpty, size } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import { initClient, initSale } from '../StockFormsStruct';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';

const initErrors = {
    shop_id: "",
    nature:"",
    products:[
        {
            product_id:"",
            quantity:"",
            priceR:"",
            priceTotal:"",
        }
    ],
}


class FormResaDemandToSale extends Component {
    state = { 
        sale: Object.assign({}, initSale),
        client: Object.assign({}, initClient, this.props.client),
        errors: Object.assign({},initErrors),
        errorsClient: Object.assign({},initClient),
        view: "sale",
        numberProd: 1,
        sending: false,
    }
    componentDidMount = () => {
        const { sale, errors } = this.state;
        const { PRODUCTS } = this.props;
        
        let newSale = Object.assign({}, sale, this.props.resa)
        let cpProducts = newSale.products
        let cpErrors = Object.assign({}, errors)
        let errProds = []
        let nbProds = size(newSale.products)
        let total = 0;
        console.log('====================================');
        console.log({sale, newSale});
        console.log('====================================');

        cpProducts.forEach( (prod, i) => {
            let option = {
                value: prod.product_id, 
                label: `${PRODUCTS[ prod.product_id ].marque} - ${PRODUCTS[ prod.product_id ].name}`
            }
            const max = this.findMax(option.value, newSale.shop_id)    
            cpProducts[i].product_id = option.value
            cpProducts[i].max = max.max
            cpProducts[i].stock_id = max.stock_id
            cpProducts[i].price = max.price
            cpProducts[i].priceR = max.price
            cpProducts[i].priceHT = max.priceHT
            cpProducts[i].prod_tva_rate = max.tva
            cpProducts[i].priceTotal = (max.price * (cpProducts[i].quantity || 0) )
            cpProducts[i].resaQty = max.resaQty
            cpProducts[i].display = option
            errProds.push({
                product_id:"",
                quantity:"",
                priceR:"",
                priceTotal:"",
            })

            total += parseFloat(cpProducts[i].priceTotal)
        })

        cpErrors.products = errProds
        newSale.products = cpProducts
        newSale.total = total
        this.setState({ 
            sale: newSale,
            errors: cpErrors,
            numberProd: nbProds,
            
        })
    }
    
    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            })
        } else if(name === "shop_id"){
            console.log("change shop_id");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                            stock_id:"",
                            price:"",
                            priceR:"",
                            priceTotal:"",
                        }
                    ],
                },
                numberProd:1
            })
            this.createAddForm()
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option
                }
            })
        }        
    }
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const shop = this.state.sale.shop_id
        const max = this.findMax(value, shop)    

        let cpProducts = this.state.sale.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max.max
        cpProducts[index].stock_id = max.stock_id
        cpProducts[index].price = max.price
        cpProducts[index].priceR = max.price
        cpProducts[index].priceHT = max.priceHT
        cpProducts[index].prod_tva_rate = max.tva
        cpProducts[index].priceTotal = (max.price * (cpProducts[index].quantity || 0) )
        cpProducts[index].resaQty = max.resaQty
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:cpProducts,
            }
        })        
    }

    findMax = (product_id, shop_id, list = this.props.AVAILABLE)=> { // return available stock and it's id
        const { PRODUCTS, resa } = this.props
        let max = 0
        let stock_id = ""
        let price = 0
        let priceHT = 0
        let tva = 0
        let resaItem = resa.products.find(prod => prod.product_id === product_id)
        let stock = Object.values(list).find(stock => stock.product_id === product_id  && stock.shop_id === shop_id ) || {quantity: 0}
        let resaQty = 0

        if( !isEmpty(resaItem) ){    // if available  = 0 but resa > 0
            resaQty = resaItem.quantity 
            max = stock.quantity + resaQty
            stock_id = ""
            price = PRODUCTS[resaItem.product_id].prix_venteTTC
            tva = PRODUCTS[resaItem.product_id].tva_rate || 0
            priceHT = PRODUCTS[resaItem.product_id].prix_venteHT

        } else if(!isEmpty(stock) ){ 
            max = stock.quantity
            stock_id = stock.id
            price = PRODUCTS[stock.product_id].prix_venteTTC
            tva = PRODUCTS[stock.product_id].tva_rate || 0
            priceHT = PRODUCTS[stock.product_id].prix_venteHT
        }
        return {
            max, 
            stock_id, 
            price, 
            priceHT, 
            tva, 
            resaQty
        }
    }

    createProductList = () => {
        const { sale } = this.state;
        const list = [{value:"", label:"Chosissez un Produit"}]
        const  { AVAILABLE, PRODUCTS } = this.props
        if(AVAILABLE){
            let selectedProds = sale.products.map( prod => prod.product_id)
            Object.values(AVAILABLE).map(stock => {   
                // Un produit désactivé n'est plus proposé au choix, même s'il
                // en reste en stock. Sa fiche reste dans le store : une ligne
                // déjà présente qui le cite continue de s'afficher.
                if (PRODUCTS[ stock.product_id ] && PRODUCTS[ stock.product_id ].is_disabled) return
                let selected = selectedProds.includes(stock.product_id)
                
                if(stock.shop_id === this.state.sale.shop_id && stock.quantity > 0){
                    list.push (       
                        {value:stock.product_id, 
                        label:`${PRODUCTS[ stock.product_id ].marque} - ${PRODUCTS[ stock.product_id ].name}`, 
                        disabled:selected
                    })
                }
            })
        }
        return list
    }
    createAddForm = () => {
        const tab = []
        const products = this.createProductList()

        // console.log("[INFO] CREATE ADD FORM INDEX ");
        for (let i = 0; i < this.state.numberProd;i++) {
            let prod = this.state.sale.products[i]
            console.log('====================================');
            console.log({prod});
            console.log('====================================');
            let background = ""
            // let resaItem = {}
            // let resaQty = 0
            if (prod.type === "resa_item") {
                background = "lightblue"
                // resaItem = this.props.resa.products.find(prod => prod.product_id === product_id)
                // resaQty = resaItem.quantity
            }
            tab.push(
                <TableRow key={i} style={{ background}}>             
                    {/* <TableCell>
                        {this.state.numberProd > 1 &&
                        <IconButton type="button" className="delete-line" onClick={()=> this.handleDeleteProd(i)}>
                            <CloseRounded />
                        </IconButton>
                        }
                     
                        <InputSelectMagasin
                            options={products}
                            value={prod.display}
                            label="Produit"
                            placeholder="Selectionner un Produit"
                            onChange={option => this.handleSelectProducts(option,i)}
                            error={this.state.errors.products[i].product_id}
                            helperText={(prod.type === "resa_item") && `Quantité reservée : ${prod.resaQty}`}
                            />    
                            
                        </TableCell> */}
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={prod.display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        helperText={(prod.type === "resa_item") && `Quantité reservée : ${prod.resaQty}`}
                    />

                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={prod.max} 
                            step={10} 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={prod.quantity} 
                            name={"prod_-quantity-"+i} 
                            title="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={prod.max ? "Disponible : "+ prod.max :"" }
                        />
                    </TableCell>
                    <TableCell>
                        <InputText 
                            disabled
                            type="number" 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={prod.price} 
                            name={"prod_-price-"+i} 
                            title="Prix"
                            error={this.state.errors.products[i].price}
                            helperText={prod.priceR ? "Prix Unitaire Base: "+ prod.priceR :"" }
                        />
                    </TableCell>
                    <TableCell className="text-center" style={{width: "100px"}}>
                        <InputText 
                            disabled
                            className="form-control input-sm" 
                            value={(prod.prod_tva_rate !== undefined && prod.prod_tva_rate !== null && prod.prod_tva_rate !== "") ? String(prod.prod_tva_rate) : "0"} 
                            name={"prod_-tva-"+i} 
                            title="TVA"
                        />
                    </TableCell>
                    <TableCell >
                        <InputText 
                            type="number" 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={prod.priceTotal } 
                            name={"prod_-priceTotal-"+i} 
                            placeholder="Prix Total"
                            error={this.state.errors.products[i].priceTotal}
                            helperText={(prod.priceR && prod.quantity) ? "Prix Total Base : "+ 
                            (prod.priceR * (prod.quantity) ):"" }
                        />
                    </TableCell>
                </TableRow>                                        
            )
        }
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the sale
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:[
                    ...this.state.sale.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    price:"",
                    priceR:"",
                    priceTotal:"",
                    priceHT:"",
                    prod_tva_rate: "",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",
                    priceR:"",
                    priceTotal:"",
                    
                }]
            },
            numberProd:this.state.numberProd+1,
            
        })   
    }
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.sale.products)
        let cpErrors = [].concat(this.state.errors.products)
        let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        cpProducts.map( prod => {
            if ( prod.priceR && prod.quantity && prod.priceTotal){
                total += parseFloat(prod.priceTotal)
            }
        }) 
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products: cpProducts,
                total
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
            
        })   
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = this.state.sale.products
            cpProducts[index][name] = value
            if(name === "quantity" || name === "price" || name === "priceTotal") {   
                if(value ==="" || regex.test(value)){// update value only if its a int
                    let discount = 0;
                    let total = 0;
                    cpProducts.map( prod => {
                        if ( prod.priceR && prod.quantity && prod.priceTotal){

                            let addDiscount = (prod.priceR * prod.quantity ) - prod.priceTotal
                            discount += addDiscount > 0 ? addDiscount : 0
                            total += parseFloat(prod.priceTotal)
                        }
                    })               
                    cpProducts[index].price = Math.round(cpProducts[index].priceTotal / cpProducts[index].quantity) || cpProducts[index].priceR
                    cpProducts[index].priceHT = Math.round(cpProducts[index].price / ( 1 + cpProducts[index].prod_tva_rate / 100))

                    this.setState({
                        ...this.state,
                        sale:{
                            ...this.state.sale,
                            products:cpProducts,
                            discount,
                            total
                        }
                    })
                }
                
            } else {
                this.setState({
                    ...this.state,
                    sale:{
                        ...this.state.sale,
                        products:cpProducts,
                    }
                })
            }
                    
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [field]:value
                }
            })
        }
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors
        const required = Object.keys(errors)
        if (this.state.sale.sale_credit){
            required.push("comments") // comment is required only if sale credit
        }

        const requiredProdItem = [ "product_id", "quantity", "priceR", "priceTotal"]
        // if(this.state.sale.nature !== "payg"){
        //     notRequired.push("cli_type", "cli_typeDisplay")
        // }

        const sale = Object.assign({}, this.state.sale)
        required.map( field => {
            console.log(field);
            if( isEmpty(sale[field]) ) {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                sale.products.map((item, j) => {
                    requiredProdItem.map( field2 => { // field2 product_id || quantity
                        
                        if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })
            } else {// not empty
                errors[field] = ""   
            }
        })
                
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        })
        if(noErrors){
            this.setState({
                view: "confirm"
                // view : "client"
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }

    // validateClient = () => {
    //     let noErrors = true
    //     let errors = this.state.errorsClient
    //     const client = Object.assign({}, this.state.client )

    //     if(!client.client_paygo_id){
            
    //         const notRequired = ["client_address", "client_email" ,"id"]
    //         if(this.state.sale.client_ref || this.state.sale.cli_type === "mjb"){ // old client with no phone number
    //             notRequired.push("client_tel")
    //         }
    //         if(this.state.sale.cli_type !== "mjb"){ // not mjb client so no paygoID
    //             notRequired.push("client_paygo_id")
    //         }
            
    //         Object.keys(client).map( field => {
    //             if( ( isEmpty(client[field]) && !notRequired.includes(field)) ) { // input is empty  
    //                 noErrors = false
    //                 errors[field]="Veuillez remplir ce champ"
    //             } else {// not empty
    //                 errors[field]=""   
    //             }
    //         })
    //         console.log("[INFO] NOERRORS = ",noErrors);
    //         console.log("[INFO] VALIDATE, ERRORS = ",errors);
            
    //         this.setState({
    //             ...this.state,
    //             errorsClient : errors
    //         })
    //     }

    //     if(noErrors){
    //         this.setState({
    //             view:"confirm",
    //             // dialogClient : false
    //         })
    //     } else {// !VALIDATE
    //         this.props.notif( "danger","Le formulaire contient des erreurs", "Erreur")
    //     }
    //     // return noErrors
    // }
    
    // handleSelectClient = (option) => {
    //     // console.log("SELECT HANDLE",{option});

    //     let value = option.value
    //     let infos = option.infos
        
    //     this.setState({
    //         ...this.state,
    //         client:{
    //             ...this.state.client,
    //             clientDisplay:option,
    //             client_lastname:infos.client_lastname,
    //             client_firstname:infos.client_firstname,
    //             client_address:infos.client_address,
    //             client_tel:infos.client_tel,
    //             client_email:infos.client_email,
    //             client_city:infos.client_city,
    //             client_country:infos.client_country,
    //             client_paygo_id:infos.client_paygo_id,
    //             id: value,
    //         },
    //         sale:{
    //             ...this.state.sale,
    //             sale_paygo_id: this.state.sale.cli_type === "mjb" ? value : "",
    //             client_ref: this.state.sale.cli_type !== "mjb" ? value : "",
    //         }
    //     })
    // }

    handleChangeClient =  (e) => {  
        const field = e.target.name
        const value = e.target.value
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                [field]:value,
            }
        })
    }
    handleSubmit = async () => {
        // const { sale, client } = this.state;
        this.setState({
            sending: true,
        })
        // let client = Object.assign({}, this.state.client)
        // sale.id = ""
        // sale.return_id = []
        // sale.client = client
        // sale.transport = parseFloat(sale.transport)                      
        // sale.taxes = parseFloat(sale.taxes) 
        let sale = Object.assign({}, this.state.sale)
        sale.date = new Date()
        sale.discount = parseFloat(sale.discount) 
        sale.total_price = parseFloat(sale.total)
        for (let i = 0; i < sale.products.length; i++){
            sale.products[i].quantity = parseInt(sale.products[i].quantity)                      
            sale.products[i].price = parseFloat(sale.products[i].priceTotal)     
        }
            
        await this.props.createSaleFromResaDemand(sale)
        
        if(this.props.STATE.sales.error){
            console.log("ERROR", this.props.STATE.sales.error);
            this.setState({
                sending: false,
            })
            toast.error( this.props.STATE.sales.error)
        } else {
            //success 
            this.setState({
                sending: false,
            })
            toast.info("Opération enregistrée avec succès")
            this.clearForms()                        
            this.props.handleClose()
        }                
    }
    clearForms = () => {
        this.setState({
            numberProd:1,
            
            sale: Object.assign({}, initSale),
            client: Object.assign({}, initClient),
            // errors?
            errors: Object.assign({}, initErrors),
            errorsClient: Object.assign({}, initClient),                
            
        })
    }

    render() {
        const { view, sale, client, errors } = this.state;
        console.log("[STATE] NEW RESSA FORM ", sale);
        console.log("[STATE] NEW errors FORM ", errors);
        // console.log("[PROPS] NEW SALE FORM ",this.props);

        const fieldList = [
            {name: "client_lastname", label:"Nom", display: client.client_lastname},
            {name: "client_firstname", label:"Prénom", display: client.client_firstname},
            {name: "client_address", label:"Adresse", display: client.client_address},
            {name: "client_city", label:"Ville", display: client.client_city},
            {name: "client_country", label:"Pays", display: client.client_country},
            {name: "client_tel", label:"Téléphone", display: client.client_tel},
            {name: "client_email", label:"Email", display: client.client_email},
            {name: "shop_id", label:"Magasin", display: sale.shop_id && this.props.SHOPS[sale.shop_id].name},
            {name: "nature", label:"Nature", display:  sale.natureDisplay.label},
            {name: "sale_credit", label: "Vente à Crédit", display: (sale.sale_credit ? "Oui" : "Non") },
            {name: "transport", label:"Coût Transport", display: sale.transport},
            {name: "taxes", label:"Autres Taxes", display: sale.taxes},        
            {name: "products"},   
            {name: "comments", label:"Commentaires",display: sale.comments},
            {name: "discount", label:"Réduction Totale", display: sale.discount},
            {name: "total", label:"Montant Total", display: sale.total},
        ]
        
        return (
            <React.Fragment>
                {view === "sale" &&
                    <div>
                        <FormSale 
                            {...this.state} 
                            {...this.props} 
                            fromResaDemand
                            handleSelect={this.handleSelect}
                            createAddForm={this.createAddForm}
                            handleAddProd={this.handleAddProd}
                            handleChange={this.handleChange}
                            validate={this.validate}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                    }
                {/* {view === "client" &&
                    <PopUp 
                        title="Formulaire Client" 
                        close={() => this.setState({
                            view: "sale", 
                            client: Object.assign({}, initClient), 
                            client_ref: "",
                            sale_paygo_id: "", 
                        })}
                        submitAction={this.validateClient}
                    >
                        <FormClient 
                            {...this.state} 
                            {...this.props}
                            fromResaDemand
                            handleSelectClient={this.handleSelectClient}
                            handleChangeClient={this.handleChangeClient}
                            // validateClient={this.validateClient}
                        />

                    </PopUp>
                    
                } */}
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "sale"})}
                    submitAction={ this.handleSubmit }
                    submitTitle="Valider" 
                    disabledSubmit={this.props.STATE.sales.fetching || this.state.sending}
                >
                    <TableLayout>
                        <TableBody>
                        
                        {fieldList.map( field => {
                            if(this.state.client[field.name]){
                                return (
                                    <TableRow>
                                        <TableCell>{field.label}</TableCell>
                                        <TableCell colSpan={3}>{field.display}</TableCell>
                                    </TableRow>
                                )
                                
                            } else if(this.state.sale[field.name]){
                                if (field.name === "products"){
                                    return this.state.sale.products.map((prod, index)=>(
                                        <TableRow>
                                            <TableCell>{prod.display.label}</TableCell>
                                            <TableCell>{prod.quantity}x{prod.price} {prod.priceR !== parseFloat(prod.price) && <i className="linethrough">{prod.priceR}</i>}</TableCell>
                                            
                                            <TableCell><b>{ prod.priceTotal }</b></TableCell>
                                        </TableRow>
                                    ))
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell colSpan={3}>{field.display}</TableCell>
                                        </TableRow>
                                    )
                                }
                            } 
                        })

                        }                            
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default FormResaDemandToSale;